export enum DLSSize {
    EXTRA_LARGE = 'xl',
    EXTRA_SMALL = 'xs',
    LARGE = 'lg',
    MEDIUM = 'md',
    SMALL = 'sm'
}
